export const defaultStyle = {
  contentWrapper: "contentWrapper max-w-xl mx-auto px-[35px] lg:px-15",
  greenh2Heading: "greenh2Heading",
  flexContent: "flex",
  bigImage: "bigImage",
  rightContent: "rightContent",
  contentText: "contentText",
  heading: "heading",
  description: "description",
}

export const TWO_COL_8_4_WIDTH = {
  contentWrapper:
    "stateOfSnackingWrap contentWrapper max-w-xl mx-auto px-[35px] lg:px-15 md:mb-0 mb-20",
  greenh2Heading:
    "greenh2Heading capitalize px-[15px] text-left font-Light text-[24px] md:text-[48px] text-green mb-[35px] w-2/3",
  flexContent: "flex flex-col md:flex-row ",
  leftContentWrapper:
    "leftcontentWrap md:w-1/3 w-full md:px-[28px] px-0 md:pt-[30px] px-15 hover:[&>div>div>a]:text-orange hover:[&>div>div>a]:border-b-2 hover:[&>div>div>a]:no-underline",
  bigImage: "bigImdownloadLinkage pr-[15px] w-full",
  rightContent: "rightContent md:px-[15px] px-0 md:w-2/3 w-full",
  heading: "heading font-Bold uppercase  lg:text-[21px] ",
  description: "description lg:mb-[35px] hover:[&>p>a]:text-orange",
}

export const IMAGE_LEFT_TEXT_RIGHT = {
  contentWrapper: "contentWrapper max-w-xl mx-auto px-[35px] lg:px-15",
  greenh2Heading:
    "greenh2Heading text-left font-Light text-[24px] md:text-[48px] text-green mb-[35px] leading-[57.6px]",
  flexContent: "lg:flex lg:mb-[50px]",
  bigImage: "bigImage mb-[35px] lg:mb[0px] lg:pr-[15px] lg:w-[50%]",
  rightContent: "rightContent mb-[20px] lg:mb[0px] lg:px-[15px] lg:w-[50%]",
  contentText: "contentText mb-[35px] lg:mb[0px]",
  heading: "heading font-Bold uppercase mb-[25px] lg:mb-[35px] lg:text-[21px] ",
  desription: "description lg:mb-[35px]",
}

export const IMAGE_RIGHT_TEXT_LEFT = {
  contentWrapperBgColor: "bg-[#FAFAFA]",
  contentWrapper:
    "contentWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[35px] lg:px-15 py-[30px] md:py-[50px]",
  greenh2Heading:
    "text-purple font-MDLZBiteType mb-[25px] md:mb-[40px] mx-[50px] md:mx-0 text-center md:text-left md:mb-[50px] md:leading-[72px] leading-[43.2px] text-[36px] tracking-[1.2px] md:text-[60px]",
  flexContent: "flexContent",
  bigImage: "bigImage mb-[30px] px-[25px] xl:px-[15px]",
  rightContent: "rightContent hidden",
  leftContentWrapper:
    "leftcontentWrap flex flex-col-reverse lg:flex-row-reverse justify-between",
  descWrapper: "descWrapper w-full lg:w-[75%] xl:w-[50%]",
  titleOne: "titleOne",
  paraDes: "paraDes [&>*:nth-child(1)]:mb-[35px]",
}

export const TWO_COL_3_9_WIDTH = {
  heading:
    " font-bold md:text-[21px] mb-0 text-[14px] font-Regular  tracking-[0.53px] text-black mt-0 box-border md:pr-[35px] ",
  paraDes:
    "mb-0 text-[14px] md:text-[21px] font-Regular tracking-[0.53px] text-black mt-0 box-border [&>p>a]:block [&>p>a]:text-[14px] md:[&>p>a]:text-[21px] [&>p>a]:text-black [&>p>a:hover]:underline",
  authorDespOne:
    " text-[14px] md:text-[21px] font-Regular  tracking-[0.53px] text-black mt-0 box-border mt-0 mb-[16px]",
  authorDesp: " leftContentWrapper px-[35px] relative block box-border w-full",
  titleOne: "box-border mb-[30px] md:mt-0 px-[35px] md:px-0",
  titleTwo: "mb-[10px] box-border px-[35px]",
  flexContent:
    "flexContent md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto md:flex md:pb-[50px] flex flex-col-reverse md:flex-row-reverse ",
  rightContent: "col1Content md:w-3/4 md:pl-[60px] md:pr-[15px]",
  contentText: "contentText",
  leftContentWrapper:
    "col2Content md:w-1/4 md:relative md:px-[15px] md:box-border",
  description:
    " descriptionP lg:px-[0px] lg:px-[0] [&>ul]:pl-[25px] [&>ul>li]:list-disc [&>p]:mb-[35px] last:[&>p]:mb-0 px-[35px] md:px-[0px] ",
  LinkTwo:
    "text-[14px] block mb-[10px] font-normal tracking-[0.53px] text-black relative box-border font-Regular px-[35px] md:text-[21px] md:px-0",
}
export const Packaging_Plastic_8_4 = {
  contentWrapper:
    "Packing_plastics contentWrapper max-w-xl mx-auto px-[35px] lg:px-15 md:mb-0 mb-20 py-[50px]",
  greenh2Heading:
    "greenh2Heading capitalize px-[15px] text-left font-Light text-[24px] md:text-[48px] text-green mb-[35px] w-2/3",
  flexContent: "flex md:flex-row-reverse flex-col",
  leftContentWrapper: "leftcontentWrap  px-0 md:w-2/3 w-full",
  bigImage: "bigImage pr-[15px] w-full",
  rightContent:
    "rightContent md:w-1/3 w-full md:px-[28px] px-0 md:pt-[30px] px-15 md:px-[15px]",
  heading:
    "heading capitalize text-left font-Light text-[24px] md:text-[48px] text-green mb-[45px] md:leading-[72px]",
  description: "description lg:mb-[35px]",
}
export const TWO_COL_4_8_WIDTH_GREEN_BG = {
  ...TWO_COL_8_4_WIDTH,
  contentWrapper: "contentWrapper lg:max-w-lg xl:max-w-xl mx-auto px-[30px] lg:px-15 my-30",
  flexContent: "flex flex-col-reverse md:flex-row-reverse ",
  leftContentWrapper:
    "leftcontentWrap md:w-1/3 w-full bg-darkGreen flex items-center justify-center px-20 py-[10px] md:py-0",
  rightContent:
    "rightContent flex md:w-2/3 w-full bg-aquaSpring md:px-[25px] md:py-[8px] ",
  heading:
    "heading font-MDLZBiteType uppercase text-white text-center text-[20px] lg:text-[29px] tracking-normal leading-[20px] lg:leading-[29px]",
  description:
    "description font-['Segoe_UI'] text-[14px] text-center lg:text-[20px] lg:text-left [&>p>a]:font-bold [&>p>a:hover]:text-orange [&>p>a:hover]:font-bold [&>p>a:hover]:underline py-[8px] px-[25px] lg:px-0 lg:py-0 tracking-normal",
}

export const TWO_COL_4_8_WIDTH_LIGHTGREY_BG = {
  ...TWO_COL_8_4_WIDTH,
  contentWrapperBgColor:
    "contentWrapperBgColor md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[30px] md:px[5px] lg:px-[15px] mb-[60px]",
  contentWrapper:
    "contentWrapper bg-lightGrey lg:pl-[5px] lg:pr-[20px] py-[40px]",
  bigImage: "  leftcontentWrap md:w-1/3 w-full px-[15px]",
  bigImg: "bigImg w-full h-full",
  description:
    "description font-Regular text-[14px] lg:text-[20px] pr-[20px] lg:px-0 mb-[25px] last:mb-0 [&>p]:mb-[25px]",
  heading:
    "heading font-Regular font-bold text-[24px] lg:text-[40px] text-green mb-[10px] leading-[48px] tracking-normal",
  flexContent: "flex flex-col md:flex-row items-center",
  rightContent: "rightContent px-[15px] mx:px-0 md:w-2/3 w-full mt-[35px]",
}

export const TWO_COL_6_WIDTH_TEXT = {
  contentWrapperBgColor: "bg-[#FAFAFA]",
  contentWrapper:
    "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[35px] lg:px-15 pb-[30px] md:pb-[50px]",
  heading:
    "capitalize text-left font-Light text-[24px] lg:text-[48px] text-green mb-[35px] md:leading-[57.5px] tracking-normal pr-[25px]",
  flexContent: "flex flex-col-reverse lg:flex-row-reverse",
  rightContent: "lg:pl-[25px]",
  leftContentWrapper: "lg:pr-[30px]",
  paraDes: "[&>p]:mb-[25px]",
  description: "[&>p]:mb-[25px]",
}

export const TWO_COL_6_WIDTH_TEXT_WITHOUT_BG = {
  contentWrapperBgColor: "contentWrapperBgColor",
  contentWrapper:
    "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[35px] lg:px-15 pb-[30px] md:pb-[50px]",
  heading:
    "capitalize text-left font-Light text-[24px] lg:text-[48px] text-green mb-[35px] md:leading-[57.5px] tracking-normal pr-[25px]",
  flexContent: "flex flex-col-reverse lg:flex-row-reverse",
  rightContent: "lg:pl-[25px] w-full lg:w-1/2",
  leftContentWrapper: "lg:pr-[30px] w-full lg:w-1/2",
  paraDes: "[&>p]:mb-[25px]",
  description: "[&>p]:mb-[25px]",
}

export const TWO_COL_6_WIDTH = {
  ...IMAGE_RIGHT_TEXT_LEFT,
  contentWrapperBgColor: "bg-[#ffffff]",
}

export const TWO_COL_6_WIDTH_WITH_DIVIDER = {
  ...TWO_COL_6_WIDTH,
}

export const ONLY_IMAGE_CENTER = {
  ...defaultStyle,
  flexContent: "flex justify-center mb-[50px]",
  bigImage: "bigImage test",
}
